import {useState} from "react";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {Sourcing} from "@/variants/index.js";

export const SourcingTab = ({material, sourcingInfo = []}) => {
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	sourcingInfo.forEach(obj => {
		obj["material"] = material;
	});

	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			data={sourcingInfo}
			pagination={tableParams.pagination}
			onChange={handleTableChange}
			columns={Sourcing.getSourcingTableColumns(sourcingInfo)}
			data-testid="sourcing-tab-table"
		/>
	);
};
